import { createApiHandler } from './handler';

const shopOrders = {
  apiClient: null,
  path: '/admin/shop-orders',

  setClient(apiClient) {
    this.apiClient = apiClient;
    this.initApiHandler();
  },

  initApiHandler() {
    Object.assign(this, createApiHandler(this.apiClient, this.path));
  },

  async list(params = {}) {
    try {
      const queryParams = new URLSearchParams();
      Object.entries(params).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          queryParams.append(key, value);
        }
      });
      const url = `${this.path}${queryParams.toString() ? `?${queryParams.toString()}` : ''}`;
      const response = await this.apiClient.get(url);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async transition(id, nextStatus) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/transition`, {
        next_status: nextStatus,
      });
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async verifyPayment(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/verify-payment`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async resendConfirmation(id, email = null) {
    try {
      const response = await this.apiClient.post(
        `${this.path}/${id}/resend-confirmation`,
        email ? { email } : {}
      );
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async markShipped(id, payload) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/mark-shipped`, payload);
      return response.data;
    } catch (error) {
      throw error;
    }
  },

  async refund(id) {
    try {
      const response = await this.apiClient.post(`${this.path}/${id}/refund`);
      return response.data;
    } catch (error) {
      throw error;
    }
  },
};

export default shopOrders;
